module.exports = __webpack_public_path__ + "img/password.be487750.svg";